import { Provider as ReduxStoreProvider } from "react-redux";

import SecuredApp from "SecuredApp";
import { store } from "store";
import "./App.css";

function App() {
  return (
    <ReduxStoreProvider store={store}>
      <SecuredApp />
    </ReduxStoreProvider>
  );
}

export default App;
